import { projects } from './index'
import { functions } from '@/firebase'

import moment from 'moment'

const createNewProject = async (name: string, userId: string, template: PublishedTemplate | null = null) => {
	const now = moment().toDate()

	const data: Project = {
		name,
		created: now,
		lastUpdated: now,
		status: 'unpublished',
		resolution: {
			width: 1024,
			height: 576
		},
		ownerUid: userId,
		_isNew: true,
		type: 'project'
	}

	if (template)
	{
		data._template = template.uid
		data.panEnabled = template.templateProps.panEnabled
		data.snapToGridSize = template.templateProps.snapToGridSize
	}

	const ref = await projects.add(data)

	return ref
}

const createNewPackage = async (name: string, userId: string) => {
	const now = moment().toDate()

	const data: Project = {
		name,
		created: now,
		lastUpdated: now,
		status: 'unpublished',
		resolution: {
			width: 1024,
			height: 576
		},
		ownerUid: userId,
		_isNew: true,
		type: 'package'
	}

	const ref = await projects.add(data)

	return ref
}

const createNewTemplate = async (name: string, userId: string) => {
	const now = moment().toDate()

	const data: Project = {
		name,
		created: now,
		lastUpdated: now,
		status: 'unpublished',
		resolution: {
			width: 1024,
			height: 576
		},
		ownerUid: userId,
		_isNew: true,
		type: 'template',
		template: {
			panEnabled: true,
			snapToGridSize: 32
		}
	}

	const ref = await projects.add(data)

	return ref
}

const deleteProject = async (projectId) => {
	const publish = functions.httpsCallable('project_delete')

	const result = await publish({ projectId: projectId })

	return result.data
}

export {
	createNewProject,
	createNewPackage,
	createNewTemplate,

	deleteProject
}
